import React, { useEffect, useRef } from "react";
import { PatientRequestForm } from "../components/patient-request-form/PatientRequestForm";

/**
 * Die oeffentliche Seite mit dem Anfrageformular. Sie steht per iframe auf der Website
 * des Kunden (Issue KAN-233) und meldet ihre Hoehe an die umgebende Seite — das
 * ausgelieferte Einbettungs-Skript wartet genau auf diese Zahl und zieht den Rahmen
 * mit. Ohne diese Meldung bliebe das Formular beim Kunden abgeschnitten.
 */
const PatientRequestFormPage = () => {
  const inhalt = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Nicht eingebettet: Dann gibt es kein Gegenueber, das die Hoehe braucht.
    if (!window.parent || window.parent === window) return;

    const element = inhalt.current;
    if (!element) return;

    let zuletztGemeldet = 0;
    const sendHeight = () => {
      // Gemessen wird der Inhalt, nie das Dokument. Das Dokument ist so hoch wie der
      // Rahmen, den das Skript gerade gesetzt hat — wer das misst, meldet seine eigene
      // Hoehe zurueck, und der Rahmen kann danach nur noch wachsen. Nach dem Absenden
      // staende unter der kurzen Bestaetigung ein grosser leerer Block.
      const hoehe = Math.ceil(element.getBoundingClientRect().height);
      // Unveraenderte Werte nicht erneut melden: Das Skript setzt daraufhin den Rahmen,
      // der Rahmen aendert den Sichtbereich, und das wuerde die naechste Meldung
      // ausloesen. Diese Rueckkopplung bricht hier ab.
      if (hoehe <= 0 || Math.abs(hoehe - zuletztGemeldet) < 2) return;
      zuletztGemeldet = hoehe;
      window.parent.postMessage(hoehe, "*");
    };

    sendHeight();
    const settleTimer = window.setTimeout(sendHeight, 300);

    // Ohne ResizeObserver (aeltere In-App-Browser) faellt nur das Mitwachsen weg. Das
    // Formular selbst muss erscheinen — ein Fehler hier wuerde die ganze Seite kosten.
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", sendHeight);
      return () => {
        window.removeEventListener("resize", sendHeight);
        window.clearTimeout(settleTimer);
      };
    }

    // Das Formular waechst noch: Haeuser werden nachgeladen, Fehlermeldungen und die
    // Bestaetigung tauschen den Inhalt aus. Jede dieser Aenderungen muss beim Kunden
    // ankommen, sonst steht der Rahmen auf der alten Hoehe.
    const heightObserver = new ResizeObserver(sendHeight);
    heightObserver.observe(element);

    return () => {
      heightObserver.disconnect();
      window.clearTimeout(settleTimer);
    };
  }, []);

  return (
    <div ref={inhalt}>
      <PatientRequestForm />
    </div>
  );
};

export default PatientRequestFormPage;
